import React, { useState } from 'react';
import { X } from 'lucide-react';
type ModalType = 'terminos' | 'privacidad' | null;
export function LegalSection() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  const closeModal = () => setActiveModal(null);
  return <>
      {/* Legal links bar */}
      <div className="bg-forest/90 py-4 px-4 text-center border-t border-gold/20" data-id="element-97">
        <div className="flex flex-wrap justify-center gap-6 text-sm" data-id="element-98">
          <button onClick={() => setActiveModal('terminos')} className="text-cream/60 hover:text-gold transition-colors duration-200 underline underline-offset-2" data-id="element-99">
            Términos y Condiciones
          </button>
          <span className="text-cream/30" data-id="element-100">|</span>
          <button onClick={() => setActiveModal('privacidad')} className="text-cream/60 hover:text-gold transition-colors duration-200 underline underline-offset-2" data-id="element-101">
            Política de Privacidad
          </button>
        </div>
      </div>

      {/* Modal overlay */}
      {activeModal && <div className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-4" onClick={closeModal} data-id="element-102">
          <div className="bg-white rounded-2xl max-w-2xl w-full max-h-[80vh] overflow-y-auto shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-103">
            {/* Modal header */}
            <div className="sticky top-0 bg-white border-b border-lightSage px-6 py-4 flex items-center justify-between rounded-t-2xl" data-id="element-104">
              <h2 className="text-xl font-heading font-bold text-forest" data-id="element-105">
                {activeModal === 'terminos' ? 'Términos y Condiciones' : 'Política de Privacidad'}
              </h2>
              <button onClick={closeModal} className="w-8 h-8 flex items-center justify-center rounded-full bg-cream hover:bg-lightSage transition-colors text-warmBrown" aria-label="Cerrar" data-id="element-106">
                <X className="w-4 h-4" data-id="element-107" />
              </button>
            </div>

            {/* Modal content */}
            <div className="px-6 py-6 space-y-6 text-warmBrown text-sm leading-relaxed" data-id="element-108">
              {activeModal === 'terminos' ? <TerminosContent data-id="element-109" /> : <PrivacidadContent data-id="element-110" />}
            </div>

            <div className="px-6 py-4 border-t border-lightSage text-center" data-id="element-111">
              <button onClick={closeModal} className="bg-sage text-white px-8 py-2 rounded-full font-medium hover:bg-forest transition-colors duration-200" data-id="element-112">
                Cerrar
              </button>
            </div>
          </div>
        </div>}
    </>;
}
function TerminosContent() {
  return <>
      <p className="text-warmBrown/60 text-xs" data-id="element-113">
        Última actualización: {new Date().getFullYear()}
      </p>

      <div data-id="element-114">
        <h3 className="font-heading font-bold text-forest text-base mb-2" data-id="element-115">
          1. Aceptación de los Términos
        </h3>
        <p data-id="element-116">
          Al adquirir y acceder a la guía digital "Menopausia en Control: Guía
          Práctica de Nutrición y Hábitos", usted acepta quedar vinculada por
          los presentes Términos y Condiciones. Si no está de acuerdo con alguno
          de estos términos, le rogamos que no realice la compra.
        </p>
      </div>

      <div data-id="element-117">
        <h3 className="font-heading font-bold text-forest text-base mb-2" data-id="element-118">
          2. Descripción del Producto
        </h3>
        <p data-id="element-119">
          El producto es una guía digital en formato descargable que contiene
          información sobre nutrición, hábitos y bienestar orientada a mujeres
          en etapa de perimenopausia y menopausia. El contenido tiene carácter
          informativo y educativo únicamente.
        </p>
      </div>

      <div data-id="element-120">
        <h3 className="font-heading font-bold text-forest text-base mb-2" data-id="element-121">
          3. Uso Permitido
        </h3>
        <p data-id="element-122">
          La guía es para uso personal y no comercial. Queda estrictamente
          prohibido reproducir, distribuir, revender, compartir o publicar el
          contenido de la guía, total o parcialmente, sin autorización expresa.
          Cada compra otorga una licencia de uso individual e intransferible.
        </p>
      </div>

      <div data-id="element-123">
        <h3 className="font-heading font-bold text-forest text-base mb-2" data-id="element-124">
          4. Entrega del Producto
        </h3>
        <p data-id="element-125">
          Al completar el pago, recibirá acceso inmediato a la guía digital. La
          entrega se realiza de forma electrónica. No se envían productos
          físicos. Es responsabilidad del usuario disponer de un dispositivo y
          conexión adecuados para acceder al contenido.
        </p>
      </div>

      <div data-id="element-126">
        <h3 className="font-heading font-bold text-forest text-base mb-2" data-id="element-127">
          5. Política de Reembolsos
        </h3>
        <p data-id="element-128">
          Dado que se trata de un producto digital con acceso inmediato, no se
          realizan reembolsos una vez completada la compra y entregado el
          acceso. Le recomendamos leer detenidamente la descripción del producto
          antes de adquirirlo.
        </p>
      </div>

      <div data-id="element-129">
        <h3 className="font-heading font-bold text-forest text-base mb-2" data-id="element-130">
          6. Aviso Médico y de Salud
        </h3>
        <p data-id="element-131">
          El contenido de esta guía tiene carácter exclusivamente informativo y
          educativo. No constituye consejo médico, diagnóstico ni tratamiento.
          Siempre consulte con un profesional de la salud calificado antes de
          realizar cambios en su dieta, hábitos o estilo de vida, especialmente
          si padece alguna condición médica.
        </p>
      </div>

      <div data-id="element-132">
        <h3 className="font-heading font-bold text-forest text-base mb-2" data-id="element-133">
          7. Propiedad Intelectual
        </h3>
        <p data-id="element-134">
          Todo el contenido de la guía, incluyendo textos, gráficos, diseño y
          estructura, está protegido por derechos de autor. Queda prohibida
          cualquier reproducción sin autorización previa y por escrito.
        </p>
      </div>

      <div data-id="element-135">
        <h3 className="font-heading font-bold text-forest text-base mb-2" data-id="element-136">
          8. Limitación de Responsabilidad
        </h3>
        <p data-id="element-137">
          Los resultados pueden variar según cada persona. No se garantizan
          resultados específicos. La responsabilidad derivada del uso de la guía
          queda limitada al valor pagado por el producto.
        </p>
      </div>

      <div data-id="element-138">
        <h3 className="font-heading font-bold text-forest text-base mb-2" data-id="element-139">
          9. Modificaciones
        </h3>
        <p data-id="element-140">
          Nos reservamos el derecho de actualizar estos Términos y Condiciones
          en cualquier momento. Las modificaciones entrarán en vigor desde su
          publicación en esta página.
        </p>
      </div>
    </>;
}
function PrivacidadContent() {
  return <>
      <p className="text-warmBrown/60 text-xs" data-id="element-141">
        Última actualización: {new Date().getFullYear()}
      </p>

      <div data-id="element-142">
        <h3 className="font-heading font-bold text-forest text-base mb-2" data-id="element-143">
          1. Información que Recopilamos
        </h3>
        <p data-id="element-144">
          Al realizar una compra, podemos recopilar datos básicos necesarios
          para procesar el pago y entregar el producto, como dirección de correo
          electrónico. No recopilamos información sensible ni datos innecesarios
          para la prestación del servicio.
        </p>
      </div>

      <div data-id="element-145">
        <h3 className="font-heading font-bold text-forest text-base mb-2" data-id="element-146">
          2. Uso de la Información
        </h3>
        <p data-id="element-147">Los datos recopilados se utilizan exclusivamente para:</p>
        <ul className="list-disc pl-5 mt-2 space-y-1" data-id="element-148">
          <li data-id="element-149">Procesar y confirmar su compra.</li>
          <li data-id="element-150">Entregar el acceso al producto digital adquirido.</li>
          <li data-id="element-151">Enviar comunicaciones relacionadas con su compra.</li>
          <li data-id="element-152">Mejorar la experiencia del usuario en nuestra plataforma.</li>
        </ul>
      </div>

      <div data-id="element-153">
        <h3 className="font-heading font-bold text-forest text-base mb-2" data-id="element-154">
          3. Compartición de Datos
        </h3>
        <p data-id="element-155">
          No vendemos, alquilamos ni compartimos su información personal con
          terceros con fines comerciales. Podemos compartir datos únicamente con
          proveedores de servicios de pago y entrega digital necesarios para
          completar su compra, quienes están obligados a mantener la
          confidencialidad de sus datos.
        </p>
      </div>

      <div data-id="element-156">
        <h3 className="font-heading font-bold text-forest text-base mb-2" data-id="element-157">
          4. Cookies y Tecnologías de Seguimiento
        </h3>
        <p data-id="element-158">
          Esta página puede utilizar cookies técnicas necesarias para su
          funcionamiento. No utilizamos cookies de seguimiento publicitario sin
          su consentimiento. Puede configurar su navegador para rechazar las
          cookies, aunque esto podría afectar la funcionalidad de la página.
        </p>
      </div>

      <div data-id="element-159">
        <h3 className="font-heading font-bold text-forest text-base mb-2" data-id="element-160">
          5. Seguridad de los Datos
        </h3>
        <p data-id="element-161">
          Implementamos medidas técnicas y organizativas razonables para
          proteger su información personal contra accesos no autorizados,
          pérdida o alteración. Sin embargo, ningún sistema de transmisión de
          datos por internet es completamente seguro.
        </p>
      </div>

      <div data-id="element-162">
        <h3 className="font-heading font-bold text-forest text-base mb-2" data-id="element-163">
          6. Conservación de Datos
        </h3>
        <p data-id="element-164">
          Conservamos sus datos personales únicamente durante el tiempo
          necesario para cumplir con los fines descritos en esta política o
          según lo exija la legislación aplicable.
        </p>
      </div>

      <div data-id="element-165">
        <h3 className="font-heading font-bold text-forest text-base mb-2" data-id="element-166">
          7. Sus Derechos
        </h3>
        <p data-id="element-167">
          Usted tiene derecho a acceder, rectificar y solicitar la eliminación
          de sus datos personales. También puede oponerse al tratamiento de sus
          datos o solicitar su portabilidad, en los casos previstos por la
          legislación vigente.
        </p>
      </div>

      <div data-id="element-168">
        <h3 className="font-heading font-bold text-forest text-base mb-2" data-id="element-169">
          8. Menores de Edad
        </h3>
        <p data-id="element-170">
          Este producto está dirigido a personas mayores de 18 años. No
          recopilamos conscientemente datos de menores de edad.
        </p>
      </div>

      <div data-id="element-171">
        <h3 className="font-heading font-bold text-forest text-base mb-2" data-id="element-172">
          9. Cambios en esta Política
        </h3>
        <p data-id="element-173">
          Nos reservamos el derecho de actualizar esta Política de Privacidad.
          Cualquier cambio será publicado en esta página con la fecha de
          actualización correspondiente. El uso continuado del sitio tras dichos
          cambios implica la aceptación de la nueva política.
        </p>
      </div>
    </>;
}